import React from 'react';
import { InputNumber, InputNumberProps } from 'antd';
import { twMerge } from 'tailwind-merge';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';

interface Props {
  className?: string;
  classNameLabel?: string;
  classNameInput?: string;
  required?: boolean;
  label?: string;
  error?: string;
  onChange?: (e) => void;
  name?: string;
}

const formatCurrency = (value: string | number) => {
  if (!isString(value) && !isNumber(value)) return '';

  if (isString(value)) {
    if (!value) return '';
    return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(Number(value));
  }

  return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(Number(value));
};

export function InputFieldNumber(props: Props & InputNumberProps) {
  const { className, classNameLabel, label, classNameInput, name, error, required, ...prop } =
    props;

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className={twMerge('text-gray_800 text-sm mb-2 block', classNameLabel)}
        >
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      <InputNumber
        name={name}
        className={twMerge('border border-gray_300 !w-full', classNameInput)}
        value={formatCurrency(prop.value)}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value) => value?.replace(/\$\s?|(,*)/g, '') as unknown as number}
        {...prop}
      />
      {error && <span className="text-sm text-error">{error}</span>}
    </div>
  );
}
